import isEqual from 'lodash/isEqual';
import React from 'react';
import {Dimensions, Image, View, StyleSheet, Text} from 'react-native';
import {Button, Input} from 'react-native-elements';
import {toast} from 'react-toastify';
import {SignUp} from '../../network/Network';
import MainSiteHeader from '../../components/MainSiteHeader';

const HEIGHT = Dimensions.get('window').height;
const WIDTH = Dimensions.get('window').width;

export default class SetPasswordScreen extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      mobileNum: this.props.route.params
        ? this.props.route.params.mobileNum
          ? this.props.route.params.mobileNum
          : ''
        : '',
      username: this.props.route.params
        ? this.props.route.params.username
          ? this.props.route.params.username
          : ''
        : '',
      otp: '',
      password: '',
      confirmPassword: '',
      isLoading: false,
      isFormTouched: false,
      isOtpValid: false,
      isPasswordValid: false,
      isConfirmPasswordValid: false,
      otpErrMsg: 'OTP is required.',
      passwordErrMsg: 'Password is required.',
      confirmPasswordErrMsg: 'Confirm password is required.'
    };
  }

  componentDidMount() {
    //
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!isEqual(nextProps, this.props) || !isEqual(nextState, this.state)) {
      return true;
    } else {
      return false;
    }
  }

  onSignUpPress = () => {
    this.setState({
      isFormTouched: true
    });
    if(!this.state.isOtpValid || !this.state.isPasswordValid || !this.state.isConfirmPasswordValid){
      return false;
    }
    this.setState({
      isLoading: true,
    });
    SignUp(
      this.state.mobileNum,
      this.state.username,
      this.state.password,
      this.state.otp,
    ).then((data) => {
      if (
        data.success == true &&
        data.status == 201 &&
        data.data.success == true
      ) {
        this.props.navigation.goBack();
      } else {
        toast(data.data.message);
      }
      this.setState({
        isLoading: false
      });
    })
    .catch((r) => {
      console.log(r);
      toast("Error, try again.");
      this.setState({
        isLoading: false
      });
    });
  };

  onOtpChange = (input) => {
    const regex = /^[0-9\b]+$/;
    if(regex.test(input)){
      if(input.length < 6){
        this.setState({
          otp: input,
          isOtpValid: false,
          otpErrMsg: 'OTP must be 6 digit long.'
        });
      } else{
        this.setState({
          otp: input,
          isOtpValid: true,
          otpErrMsg: ''
        });
      }
    } else{
      this.setState({
        otp: input,
        isOtpValid: false,
        otpErrMsg: 'OTP must be in digits.'
      });
    }
  }
  
  onPasswordChange = (input) => {
    if(input.length < 8){
      this.setState({
        password: input,
        isPasswordValid: false,
        passwordErrMsg: 'Password must be 8 characters long.'
      });
    } else{
      this.setState({
        password: input,
        isPasswordValid: true,
        passwordErrMsg: ''
      });
    }
  }
  
  onConfirmPasswordChange = (input) => {
    if(input != this.state.password){
      this.setState({
        confirmPassword: input,
        isConfirmPasswordValid: false,
        confirmPasswordErrMsg: 'Password should match.'
      });
    } else{
      this.setState({
        confirmPassword: input,
        isConfirmPasswordValid: true,
        confirmPasswordErrMsg: ''
      });
    }
  }

  render() {
    return (
      <View style={styles.viewStyle}>
        <MainSiteHeader/> 
          <View style={styles.loginContainer}>
            <View style={{width: WIDTH < 720 ? WIDTH * 0.9 : WIDTH / 3, backgroundColor: '#000000', padding: 16, alignSelf: 'center'}}>
              <Image
                source={process.env.PUBLIC_URL + '/assets/ulka-1.png'}
                style={{height: 100, width: 200, alignSelf: 'center'}}
              />
              <Text style={{ color: 'white', marginHorizontal: 16, marginTop: 16, alignSelf: 'center' }}>We have sent the OTP on mobile number +91 XXXXXXXX{this.state.mobileNum.substr(this.state.mobileNum.length - 4)}</Text>
              <Text style={{ color: 'white', marginHorizontal: 16, marginBottom: 16, alignSelf: 'center' }}>Your User ID is {this.state.username}&nbsp;<a href="javascript:;" onClick={() => this.props.navigation.goBack()}>Change</a></Text>
              <Input
                placeholder={'OTP'}
                inputStyle={styles.inputStyle}
                placeholderTextColor="white"
                value={this.state.otp}
                onChangeText={this.onOtpChange.bind(this)}
              />
              {this.state.isFormTouched && !this.state.isOtpValid && (
                <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{this.state.otpErrMsg}</Text>
              )}
              <Input
                placeholder={'Password'}
                inputStyle={styles.inputStyle}
                placeholderTextColor="white"
                secureTextEntry={true}
                value={this.state.password}
                onChangeText={this.onPasswordChange.bind(this)}
              />
              {this.state.isFormTouched && !this.state.isPasswordValid && (
                <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{this.state.passwordErrMsg}</Text>
              )}
              <Input
                placeholder={'Confirm Password'}
                inputStyle={styles.inputStyle}
                placeholderTextColor="white"
                secureTextEntry={true}
                value={this.state.confirmPassword}
                onChangeText={this.onConfirmPasswordChange.bind(this)}
              />
              {this.state.isFormTouched && !this.state.isConfirmPasswordValid && (
                <Text style={{ color: 'red', marginLeft: 8, marginBottom: 8 }}>{this.state.confirmPasswordErrMsg}</Text>
              )}
              <Button
                raised
                loading={this.state.isLoading}
                onPress={this.onSignUpPress}
                containerStyle={styles.buttonContainerStyle}
                buttonStyle={styles.buttonStyle}
                title="SignUp"
              />
            </View>
          </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  viewStyle: {
    height: HEIGHT,
    width: WIDTH
  },
  backgroundVideo: {
    flex: 1,
    position: "absolute",
    top: 0,
    left: 0,
    alignItems: "stretch",
    bottom: 0,
    right: 0
  },
  loginContainer: {
    justifyContent: 'center',
    alignItems: 'center',
    textAlignVertical: 'center',
    alignContent: 'center',
    height: HEIGHT-72,
  },
  imageStyle: {
    height: 100, 
    width: 200, 
    alignSelf: 'center', 
    marginBottom: 24
  },
  inputStyle: {
    color: 'white', 
    marginBottom: 8
  },
  buttonStyle: {
    backgroundColor: 'red',
    height: 50
  },
  buttonContainerStyle: {
    marginTop: 16
  },
  moreViewStyle: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 20,
  },
  textStyle: {
    color: 'white',
    fontSize: 16,
    textDecorationLine: true,
  },
});